// extracted by mini-css-extract-plugin
module.exports = {"container":"text-card-list_container__7lvNE","item":"text-card-list_item___5WNu"};